import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=c187e972&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"
import style0 from "./Logo.vue?vue&type=style&index=0&id=c187e972&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c187e972",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c187e972')) {
      api.createRecord('c187e972', component.options)
    } else {
      api.reload('c187e972', component.options)
    }
    module.hot.accept("./Logo.vue?vue&type=template&id=c187e972&scoped=true", function () {
      api.rerender('c187e972', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/ezpay/Sidebar/Logo.vue"
export default component.exports